
export class ContextDataValueEmb {
value: Object;
}

